/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Sign up"
    }), "\n", _jsx(_components.h2, {
      children: "Personal/SaaS signup"
    }), "\n", _jsxs(_components.p, {
      children: ["The signup process is typical. Visit ", _jsx(_components.a, {
        href: "/auth/signup",
        children: "the signup page"
      }), " to get started."]
    }), "\n", _jsx(_components.p, {
      children: "You will be asked a number of questions and we will highly appreciate if\nyou let us contact you to discuss your requirements."
    }), "\n", _jsx(_components.h2, {
      children: "Enterprise accounts"
    }), "\n", _jsxs(_components.p, {
      children: ["Please ", _jsx(_components.a, {
        href: "/contact",
        children: "get in touch"
      }), " to discuss your enterprise requirements including team access, deployment in private cloud / VPC and more."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
